export default function CheckoutDesignLpPage() {
  return <div />;
}
